@if (isLoading) {
<div class="d-flex justify-content-center p-24">
  <mat-spinner diameter="32"></mat-spinner>
</div>
} @else if (occupancyData) {
<!-- Summary Bar -->
<div class="d-flex gap-16 m-b-16 flex-wrap">
  <mat-chip-set>
    <mat-chip class="bg-light-success" [class.selected-chip]="bedFilter === 'available'"
      (click)="bedFilter = 'available'">
      <i-tabler name="bed" class="icon-14 m-r-4"></i-tabler>
      {{ 'LABEL.AVAILABLE' | translate }}: {{ occupancyData.availableBeds }}
    </mat-chip>
    <mat-chip class="bg-light-error" [class.selected-chip]="bedFilter === 'occupied'" (click)="setOccupiedFilter()">
      <i-tabler name="bed-filled" class="icon-14 m-r-4"></i-tabler>
      {{ 'LABEL.OCCUPIED' | translate }}: {{ occupancyData.occupiedBeds }}
    </mat-chip>
    <mat-chip class="bg-light-primary" [class.selected-chip]="bedFilter === 'all'" (click)="bedFilter = 'all'">
      <i-tabler name="bed" class="icon-14 m-r-4"></i-tabler>
      {{ 'LABEL.TOTAL_BEDS' | translate }}: {{ occupancyData.totalBeds }}
    </mat-chip>
  </mat-chip-set>
</div>


<!-- Ward Panels -->
<div class="ward-scroll-area">
  <mat-accordion multi>
    @for (ward of occupancyData.wards; track ward.wardId) {
    @if (hasVisibleBedsInWard(ward)) {
    <mat-expansion-panel [expanded]="true" class="expand-panel-display">
      <mat-expansion-panel-header class="bg-light-primary">
        <mat-panel-title class="f-w-600">
          <i-tabler name="building-hospital" class="icon-18 m-r-8"></i-tabler>
          {{ ward.wardName }}
        </mat-panel-title>
        <mat-panel-description>
          {{ ward.occupiedBeds }}/{{ ward.totalBeds }} {{ 'LABEL.OCCUPIED' | translate }}
        </mat-panel-description>
      </mat-expansion-panel-header>

      @for (room of ward.rooms; track room.roomId) {
      @if (hasVisibleBeds(room)) {
      <div class="room-section">
        <div class="room-label f-w-600 f-s-14 m-b-8">
          {{ room.roomNumber }} <span class="mat-body-1">({{ room.roomTypeName }})</span>
          @if (room.floor) {
          <span class="mat-body-1"> - {{ 'LABEL.FLOOR' | translate }}: {{ room.floor }}</span>
          }
        </div>
        <div class="bed-grid">
          @for (bed of room.beds; track bed.bedId) {
          @if (isBedVisible(bed)) {
          <div class="bed-chip" [class.available]="!isOccupied(bed)" [class.occupied]="isOccupied(bed)"
            (click)="isOccupied(bed) ? onBedClick(bed) : null"
            [matTooltip]="isOccupied(bed) && bed.admissionDate ? ('Admitted: ' + (bed.admissionDate | date:'dd/MM/yyyy')) : ''">
            <i-tabler [name]="isOccupied(bed) ? 'bed-filled' : 'bed'" class="icon-16 m-r-4"></i-tabler>
            <span>{{ bed.bedNumber }}</span>
            @if (isOccupied(bed) && bed.patientName) {
            <span class="bed-patient-name">{{ bed.patientName }}</span>
            <span class="bed-ipd-number">{{ bed.ipdNumber }}</span>
            }
          </div>
          }
          }
        </div>
      </div>
      }
      }
    </mat-expansion-panel>
    }
    }
  </mat-accordion>

  @if (occupancyData.wards.length === 0) {
  <div class="d-flex justify-content-center p-24">
    <span class="mat-body-1">{{ 'LABEL.NO_DATA' | translate }}</span>
  </div>
  }
</div>
}